import React from 'react'
import Link from 'gatsby-link'
import styled from "styled-components";

require('typeface-inconsolata')
require('./style.css')

const Header = styled.header`
  display:block;
  position:relative;
  padding: 15px 0px 0px 15px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  @media screen and (min-width: 1024px) {
    width:800px;
  }
`

const H1 = styled.h1`
  display: inline;
  font-size: 50px;
  font-weight:bold;
  color:black;
  a {
    color: black;
  }
  small {
    font-size: "77.7%"
  }
`

const Content = styled.div`
  display:block;
  width: 100%;
  margin-top:20px;
  margin-bottom:20px;
  margin-left: auto;
  margin-right: auto;
  padding: 15px;

  @media screen and (min-width: 1024px) {
    width: 800px;
  }
`

class Template extends React.Component {
  render() {
    const { data, children } = this.props
    console.log(data)
    return (
      <div id="container">
        <Header>
          <H1>
            <a href="/">{data.site.siteMetadata.title}</a>
          </H1>
        </Header>
        <Content>
          {children()}
        </Content>
      </div>
    )
  }
}

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.jsx